import React from "react";
import { Outlet } from "react-router-dom";
import ShellHeader from "./ShellHeader";

/**
 * Nested layout mounted inside `CustomerLayout`, wrapping only customer-apps' own baseline
 * flag-gated surfaces (`AppRouter.tsx`'s first `ShellLayout` block: home/item-browser/browse/
 * collections/etc., and its second: index/item-detail/collections-browser). AB Vault, Spotter,
 * and Metadata Import are NOT nested here — see `docs/decisions.md` for why — each renders its
 * own fully self-contained header (`AbHeader`/`SpotterHeader`/`MetadataImportHeader`) directly
 * under `CustomerLayout` instead.
 */
const ShellLayout = () => (
  <>
    <ShellHeader />
    <Outlet />
  </>
);

export default ShellLayout;
